<div class="notifications-page">
  <header class="page-header">
    <div class="page-header__titles">
      <h1>{{ 'notifications.title' | translate }}</h1>
      <p class="page-header__subtitle">{{ 'notifications.pageSubtitle' | translate }}</p>
    </div>
    <div class="page-header__actions">
      <button type="button" class="primary-btn" *ngIf="canBroadcastNotifications"
              (click)="openNotifyBroadcastPanel()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
          <line x1="12" y1="5" x2="12" y2="19"></line>
          <line x1="5" y1="12" x2="19" y2="12"></line>
        </svg>
        {{ 'notifications.newNotification' | translate }}
      </button>
    </div>
  </header>

  <div class="scope-notice" *ngIf="isScopedView">
    <svg class="scope-notice__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="12" y1="16" x2="12" y2="12"></line>
      <line x1="12" y1="8" x2="12.01" y2="8"></line>
    </svg>
    <span>{{ 'notifications.scopeNotice' | translate }}</span>
  </div>

  <div class="tabs">
    <button type="button" class="tab" [class.active]="activeTab === 'personal'"
            (click)="selectTab('personal')">
      {{ 'notifications.tabs.personal' | translate }}
      <span class="tab__count">{{ counts.personal }}</span>
    </button>
    <button type="button" class="tab" *ngIf="showAdminTab" [class.active]="activeTab === 'admin'"
            (click)="selectTab('admin')">
      {{ 'notifications.tabs.admin' | translate }}
      <span class="tab__count">{{ counts.admin }}</span>
    </button>
    <button type="button" class="tab" [class.active]="activeTab === 'entity'"
            (click)="selectTab('entity')">
      {{ (showAdminTab ? 'notifications.tabs.entityAll' : 'notifications.tabs.entity') | translate }}
      <span class="tab__count">{{ counts.entity }}</span>
    </button>
  </div>

  <div class="toolbar">
    <input type="text" class="text-input" [(ngModel)]="search" (ngModelChange)="onSearchChange()"
           [placeholder]="'notifications.searchPlaceholder' | translate">

    <div class="segmented">
      <button type="button" *ngFor="let r of readFilters"
              [class.active]="readFilter === r" (click)="selectReadFilter(r)">
        {{ 'notifications.readFilters.' + r | translate }}
      </button>
    </div>

    <div class="type-filters">
      <button type="button" class="type-filter" *ngFor="let f of typeFilters"
              [class.active]="activeType === f" [ngClass]="'type-' + f"
              (click)="selectType(f)">
        {{ 'notifications.filters.' + f | translate }}
      </button>
    </div>
  </div>

  <!-- Barra di selezione: le azioni in blocco mostrate dipendono dallo stato
       delle righe selezionate (solo quelle su cui c'è qualcosa da applicare). -->
  <div class="selection-bar" *ngIf="items.length > 0">
    <label class="select-all">
      <input type="checkbox" [checked]="allSelected" (change)="toggleSelectAll()">
      <span>{{ 'notifications.selectAll' | translate }}</span>
    </label>

    <ng-container *ngIf="selectedCount > 0; else markAllTpl">
      <span class="selection-bar__count">
        {{ 'notifications.selectedCount' | translate: { count: selectedCount } }}
      </span>
      <button type="button" class="primary-btn compact" *ngIf="selectedUnreadCount > 0"
              (click)="markSelectedAsRead()">
        {{ 'notifications.markSelectedAsRead' | translate }}
      </button>
      <button type="button" class="secondary-btn compact" *ngIf="selectedReadCount > 0"
              (click)="markSelectedAsUnread()">
        {{ 'notifications.markSelectedAsUnread' | translate }}
      </button>
      <button type="button" class="link-btn" (click)="clearSelection()">
        {{ 'notifications.clearSelection' | translate }}
      </button>
    </ng-container>

    <ng-template #markAllTpl>
      <button type="button" class="link-btn" *ngIf="unreadInView > 0" (click)="markAllAsRead()">
        {{ 'notifications.markAllAsRead' | translate }}
      </button>
    </ng-template>
  </div>

  <div class="notification-list">
    <!-- Nessuna notifica in assoluto (nessun filtro attivo) -->
    <div *ngIf="!loading && items.length === 0 && !hasAnyNotifications" class="notification-empty">
      <svg class="empty-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
        <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
      </svg>
      <p>{{ 'notifications.empty' | translate }}</p>
    </div>

    <!-- Nessun risultato per il tab/filtro/ricerca corrente -->
    <div *ngIf="!loading && items.length === 0 && hasAnyNotifications" class="notification-empty">
      <p>{{ 'notifications.noResults' | translate }}</p>
    </div>

    <div *ngFor="let notification of items; trackBy: trackById"
         class="notification-item"
         [class.notification-item--unread]="!notification.Managed"
         [class.notification-item--clickable]="notification.Refferal"
         [ngClass]="typeClass(notification.MessageType)"
         (click)="open(notification)">
      <div class="notification-content">
        <!-- Selezione: su tutte le righe, lette incluse (si può riportarle a
             non lette in blocco). -->
        <label class="row-select" (click)="$event.stopPropagation()">
          <input type="checkbox"
                 [checked]="isSelected(notification)"
                 [attr.aria-label]="'notifications.selectRow' | translate"
                 (change)="toggleSelection(notification, $event)">
        </label>

        <!-- Icona tipo -->
        <div class="notification-icon" [ngSwitch]="notification.MessageType">
          <svg *ngSwitchCase="'success'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10"></circle>
            <path d="M9 12l2 2 4-4"></path>
          </svg>
          <svg *ngSwitchCase="'error'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="15" y1="9" x2="9" y2="15"></line>
            <line x1="9" y1="9" x2="15" y2="15"></line>
          </svg>
          <svg *ngSwitchCase="'warning'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
            <line x1="12" y1="9" x2="12" y2="13"></line>
            <line x1="12" y1="17" x2="12.01" y2="17"></line>
          </svg>
          <svg *ngSwitchDefault viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="16" x2="12" y2="12"></line>
            <line x1="12" y1="8" x2="12.01" y2="8"></line>
          </svg>
        </div>

        <!-- Testo integrale -->
        <div class="notification-text">
          <p class="notification-message">{{ notification.Message }}</p>
          <div class="notification-meta">
            <span class="notification-time" [attr.title]="formatFullDate(notification.EventTimestamp)">
              {{ formatDate(notification.EventTimestamp) }}
            </span>
            <span class="notification-entity" *ngIf="notification.EntityName">
              {{ notification.EntityName }}
            </span>
          </div>
        </div>

        <!-- Azione, non stato: spunta per segnare letta, freccia di ripristino
             per riportarla a non letta. -->
        <button type="button"
                class="mark-read-button"
                [class.mark-read-button--undo]="notification.Managed"
                [attr.title]="(notification.Managed ? 'notifications.markAsUnread' : 'notifications.markAsRead') | translate"
                [attr.aria-label]="(notification.Managed ? 'notifications.markAsUnread' : 'notifications.markAsRead') | translate"
                (click)="toggleReadState(notification, $event)">
          <svg *ngIf="!notification.Managed" viewBox="0 0 24 24" fill="none" stroke="currentColor"
               stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
          <svg *ngIf="notification.Managed" viewBox="0 0 24 24" fill="none" stroke="currentColor"
               stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <polyline points="1 4 1 10 7 10"></polyline>
            <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path>
          </svg>
        </button>
      </div>
    </div>

    <p class="load-more-hint" *ngIf="loading">{{ 'notifications.loading' | translate }}</p>

    <!-- Sentinella infinite scroll: sempre nel DOM per un ViewChild stabile. -->
    <div #loadMoreSentinel class="load-more-sentinel" aria-hidden="true"></div>
    <p class="load-more-hint" *ngIf="loadingMore || (hasMore && items.length > 0)">
      {{ 'notifications.loadingMore' | translate }}
    </p>
  </div>
</div>

<app-notify-broadcast-panel
  *ngIf="notifyBroadcastPanelOpen"
  (close)="closeNotifyBroadcastPanel()">
</app-notify-broadcast-panel>
